import { useQuery } from "react-query";
import { fetchValproCardData } from "./api";

export function useValproCard(filters, options = {}) {
  return useQuery(
    ["fetchValproCardData", filters],
    () => fetchValproCardData(filters),
    {
      staleTime: 0,
      ...options,
    }
  );
}
